module.exports = __webpack_public_path__ + "8ae43cdc1ba6074a2a6c5097f906fdd3.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-420.webp.png
// module id = 622
// module chunks = 0